/**
 * Atlas PM · 项目运营模式（P8.7）
 *
 * 固定两种取值（非字典表，管理员无需维护）：
 *   POS = 全运营服务
 *   DOS = 数据运营服务
 *
 * 数据库约束：project.operating_mode VARCHAR(8) NOT NULL DEFAULT 'POS'
 *             + CHECK (operating_mode IN ('POS','DOS'))
 */
export const PROJECT_OPERATING_MODE = {
    POS: 'POS',
    DOS: 'DOS',
};
/** 表单 / 展示用选项（顺序固定：POS 在前） */
export const PROJECT_OPERATING_MODE_OPTIONS = [
    { value: PROJECT_OPERATING_MODE.POS, label: 'POS（全运营服务）' },
    { value: PROJECT_OPERATING_MODE.DOS, label: 'DOS（数据运营服务）' },
];
/** 取运营模式中文标签；未知值原样返回 */
export function projectOperatingModeLabel(value) {
    return PROJECT_OPERATING_MODE_OPTIONS.find((o) => o.value === value)?.label ?? value;
}
//# sourceMappingURL=project-operating-mode.js.map